import { Injectable } from '@angular/core';

import {
	NodeChangeType,
	CombiningSubscriptionManager,
	SubscriptionManagerService
} from '@shure/shared/angular/data-access/system-api/core';
import { ILogger } from '@shure/shared/angular/utils/logging';

import {
	ChannelCrossPointSubscriptionGQL,
	ChannelEqualizerFilterSubscriptionGQL,
	ChannelSubscriptionGQL,
	ChannelInfoDeviceRfChannelSubscriptionGQL
} from '../graphql/generated/channel-info-channel.generated';
import { DeviceSubscriptionGQL } from '../graphql/generated/channel-info-device.generated';

@Injectable()
export class DaiChannelInfoSubscriptionsService {
	public readonly device: CombiningSubscriptionManager;
	public readonly channels: CombiningSubscriptionManager;
	public readonly rfChannels: CombiningSubscriptionManager;
	public readonly crosspoints: CombiningSubscriptionManager;
	public readonly equalizer: CombiningSubscriptionManager;

	constructor(
		logger: ILogger,
		channelSubscriptionGQL: ChannelSubscriptionGQL,
		deviceSubscriptionGQL: DeviceSubscriptionGQL,
		channelCrossPointSubscriptionGQL: ChannelCrossPointSubscriptionGQL,
		channelEqualizerFilterSubscriptionGQL: ChannelEqualizerFilterSubscriptionGQL,
		schematicsDeviceRfChannelSubscriptionGQL: ChannelInfoDeviceRfChannelSubscriptionGQL,
		subscriptionManagerService: SubscriptionManagerService
	) {
		this.device = new CombiningSubscriptionManager(
			{
				name: 'DaiChannelInfoSubscriptionsService:Device',
				changeTypes: [
					NodeChangeType.DeviceLogicMute,
					NodeChangeType.DeviceDanteAudioNetworkAccess,
					NodeChangeType.DeviceLicense,
					NodeChangeType.DeviceStereoAudio,
					NodeChangeType.DeviceConferencingOperationMode,
					NodeChangeType.DeviceAudioChannels,
					NodeChangeType.DeviceAnalogAudioOutputMode,
					NodeChangeType.DeviceAllIntellimixBypass,
					NodeChangeType.DeviceDectRfSpectrumScan,
					NodeChangeType.DeviceUsbConnection,
					NodeChangeType.DeviceTransmitterMuteBehavior
				],
				subscriptionGql: deviceSubscriptionGQL
			},
			logger,
			subscriptionManagerService
		);

		this.channels = new CombiningSubscriptionManager(
			{
				name: 'DaiChannelInfoSubscriptionsService:Channel',
				changeTypes: [
					NodeChangeType.AudioChannelAcousticEchoCancellation,
					NodeChangeType.AudioChannelAcousticEchoCancellationMonoReference,
					NodeChangeType.AudioChannelAcousticEchoCancellationStereoReference,
					NodeChangeType.AudioChannelAutomaticGainControl,
					NodeChangeType.AudioChannelCompressor,
					NodeChangeType.AudioChannelDelay,
					NodeChangeType.AudioChannelEqualizer,
					NodeChangeType.AudioChannelLimiter,
					NodeChangeType.AudioChannelNoiseReduction,
					NodeChangeType.AudioChannelDenoiser,
					NodeChangeType.AudioChannelDeverb,
					NodeChangeType.AudioChannelName,
					NodeChangeType.AudioChannelGain,
					NodeChangeType.AudioChannelMute,
					NodeChangeType.AudioChannelPostGateMute,
					NodeChangeType.AudioChannelAnalogLevel,
					NodeChangeType.AudioChannelDanteEncryptionStatus,
					NodeChangeType.AudioChannelPcPeripheral,
					NodeChangeType.AudioChannelInputSource,
					NodeChangeType.AudioChannelOutputPath,
					NodeChangeType.AudioChannelSelectedLoudspeaker,
					NodeChangeType.AudioChannelChannelConfiguration,
					NodeChangeType.AudioChannelCarriedByRfChannels,
					NodeChangeType.AudioChannelAnalogInputUse
				],
				subscriptionGql: channelSubscriptionGQL
			},
			logger,
			subscriptionManagerService
		);

		this.rfChannels = new CombiningSubscriptionManager(
			{
				name: 'DaiChannelInfoSubscriptionsService:RfChannel',
				changeTypes: [NodeChangeType.RfChannelLinkedTransmitter],
				subscriptionGql: schematicsDeviceRfChannelSubscriptionGQL
			},
			logger,
			subscriptionManagerService
		);

		this.crosspoints = new CombiningSubscriptionManager(
			{
				name: 'DaiChannelInfoSubscriptionsService:CrossPoint',
				changeTypes: [NodeChangeType.CrossPointConfiguration],
				subscriptionGql: channelCrossPointSubscriptionGQL
			},
			logger,
			subscriptionManagerService
		);
		this.equalizer = new CombiningSubscriptionManager(
			{
				name: 'DaiChannelInfoSubscriptionsService:Eq',
				changeTypes: [NodeChangeType.EqualizerFilterConfiguration],
				subscriptionGql: channelEqualizerFilterSubscriptionGQL
			},
			logger,
			subscriptionManagerService
		);
	}
}
